/**
 * ============================================================
 * SHPE@VT IMAGE CONFIGURATION FILE
 * ============================================================
 * Edit this file to update all images used throughout the site.
 * 
 * HOW TO USE:
 * 1. Place your images in /public/images/
 * 2. Reference them as: process.env.PUBLIC_URL + '/images/your-image.jpg'
 *    OR use external URLs directly (like the Wix CDN URLs below)
 * 
 * SECTIONS:
 *  - BRANDING: Logo, icons
 *  - HERO: Homepage banner/background
 *  - EBOARD: Executive board member photos
 *  - EVENTS: Event photos for homepage preview
 *  - PROGRAMS: Program section images
 *  - SPONSORS: Sponsor logos
 *  - GALLERY: Additional gallery photos
 * ============================================================
 */

// ── BRANDING ────────────────────────────────────────────────
export const LOGO_HORIZONTAL = 'https://static.wixstatic.com/media/dac086_583ec807fb1e4c67823fe45f2c24639e~mv2.png';
export const LOGO_VERTICAL   = 'https://static.wixstatic.com/media/dac086_3a54b611732740c689ac26a9d8487a88~mv2.png';
export const SHPE_ICON       = 'https://static.wixstatic.com/media/dac086_389fde24a0bb4fdc97b22fca735fb931~mv2.png';
export const VT_LOGO         = 'https://static.wixstatic.com/media/dac086_ba83e009d0dc412bbf48f9cf426985b4~mv2.png';

// ── HERO / HOMEPAGE ─────────────────────────────────────────
// Replace HERO_IMAGE with a wide group photo (recommended: 1920x800px)
export const HERO_IMAGE      = 'https://static.wixstatic.com/media/dac086_322be9be2cf5413aaa889eef06d62719~mv2.jpg';

// ── EXECUTIVE BOARD PHOTOS ──────────────────────────────────
// Replace each URL with the officer's headshot (recommended: 300x400px, same ratio)
// ── ADD EBOARD MEMBERS BELOW USING FORMAT ─
  // {
  //   name: 'Jane Doe',
  //   title: 'Treasurer',
  //   photo: process.env.PUBLIC_URL + '/images/jane-doe.jpg',
  //   major: 'Industrial Engineering',
  //   email: 'jane@vt.edu',
  //   linkedin: 'https://linkedin.com/in/janedoe',
  // },
export const EBOARD = [
  { //President
    name: 'Javier Ralat',
    title: 'President',
    photo: 'https://static.wixstatic.com/media/dac086_80c59d477d0f4a319d6b4e1c7c6dae47~mv2.jpg',
    major: 'Computer Engineering',
    email: 'javieraralat@vt.edu',
    linkedin: 'https://www.linkedin.com/in/javieraralat/',
  },
  { //VPI
     name: 'Yiarely Muñoz-Martinez',
    title: 'VP of Internal Affairs',
    photo: 'https://static.wixstatic.com/media/dac086_f24234a059354d5d9ffac271222464f8~mv2.jpg',
    major: 'Civil Engineering',
    email: 'yiarelym@vt.edu',
    linkedin: 'https://www.linkedin.com/in/yiarely-mu%C3%B1oz-martinez/',
  },
  { //VPE
    name: 'Matthew Yanez',
    title: 'VP of External Affairs',
    photo: 'https://static.wixstatic.com/media/dac086_0d97adb0afaa45388c2b9c6e5b053d86~mv2.jpg',
    major: 'Computer Engineering',
    email: 'mattyanez42@vt.edu',
    linkedin: 'https://www.linkedin.com/in/matthew-yanez/',
  },
  { //Outreach
    name: 'Jessica Gonzalez Solis',
    title: 'Outreach',
    photo: 'https://static.wixstatic.com/media/dac086_7f89343891714d04b089c5cd2d2de830~mv2.jpg',
    major: 'Ocean & Aerospace Engineering',
    email: 'jessmchelle28@vt.edu',
    linkedin: 'https://www.linkedin.com/in/jessica-gonzalez-solis-56b776282/',
  },
  { //SHPEtinas
    name: 'Ana Rivera',
    title: 'SHPEtinas Program Chair',
    photo: 'https://static.wixstatic.com/media/dac086_1f29043fe7514af28663fe9ff258a3e4~mv2.jpg',
    major: 'Mechanical Engineering',
    email: 'anarivera@vt.edu',
    linkedin: 'https://www.linkedin.com/in/ana-rivera6/',
  },
  { //MentorSHPE Program Chair
    name: 'Javier Millan Reyes',
    title: 'MentorSHPE Program Chair',
    photo: 'https://static.wixstatic.com/media/dac086_20420f9ee92f4428b6f424df25a41278~mv2.jpg',
    major: 'Computer Engineering',
    email: 'javierm2409@vt.edu',
    linkedin: 'https://www.linkedin.com/in/javier-millan-reyes/',
  },
  { //Treasurer
    name: 'Brian Velasco',
    title: 'Treasurer',
    photo: 'https://static.wixstatic.com/media/dac086_e2fc0d17175748a599c5dc1f7b46cf8b~mv2.jpg',
    major: 'Computer Engineering',
    email: 'brianvelasco@vt.edu',
    linkedin: 'https://www.linkedin.com/in/brianvelascoburgoa/',
  },
  { //Secretary
    name: 'Mia Padilla',
    title: 'Secretary',
    photo: 'https://static.wixstatic.com/media/dac086_97dde17cb460404eb0418f59678d2b36~mv2.jpg',
    major: 'Civil Engineering',
    email: 'miap@vt.edu',
    linkedin: 'https://www.linkedin.com/in/mia-padilla-829403383/',
  },
  { //Public Relations
    name: 'Cristian Machado',
    title: 'Public Relations',
    photo: 'https://static.wixstatic.com/media/dac086_74aa01168daa4d5ba9e67a8ece0f83d7~mv2.jpg',
    major: 'Civil Engineering',
    email: 'cmachado2025@vt.edu',
    linkedin: 'https://www.linkedin.com/in/cristian-machado-giron-902338318/',
  },
  { //Conference Coordinator
    name: 'David Hernandez',
    title: 'Conference Coordinator',
    photo: '',
    major: 'Civil Engineering',
    email: 'dehernandez0729@vt.edu',
    linkedin: 'https://www.linkedin.com/in/dehernandez152/',
  },
  { //Webmaster
    name: 'Alex Rios',
    title: 'Webmaster',
    photo: 'https://static.wixstatic.com/media/dac086_8d2c873c36cc483f9d0abe17a7ebdaea~mv2.jpg',
    major: 'Computer Science',
    email: 'arios8@vt.edu',
    linkedin: 'https://www.linkedin.com/in/alejandro-r-671271216/',
  },
  { //Historian
    name: 'Esteban Yanez',
    title: 'Historian',
    photo: 'https://static.wixstatic.com/media/dac086_68c34da057d4431684a0ccdd4c2f0adb~mv2.jpg',
    photoZoom: 1.2,
    //photoFocus: '90% 90%',
    major: 'Computer Science',
    email: 'esteban24@vt.edu',
    linkedin: 'https://www.linkedin.com/in/eayanez/',
  },
  { //Blacksburg Campus Grad Chair
    name: 'Amber Amaral-Torres',
    title: 'Blacksburg Campus Grad Chair',
    photo: 'https://static.wixstatic.com/media/dac086_626ab9c72bef4d60aed1959e9ea75b0d~mv2.jpg',
    major: 'Civil and Enviornmental Engineering',
    email: 'aaamber@vt.edu',
    linkedin: '',
  },
  { //Innovation Campus Grad Chair
    name: 'Raphael Rodriguez',
    title: 'Innovation Campus Grad Chair',
    photo: '/images/Eboard/Raph.png',
    photoZoom: 1,
    photoFocus: '50% 50%',
    major: 'Computer Engineering',
    email: 'rapcole12@vt.edu',
    linkedin: '',
  },
  { //SEC Representative
    name: 'Emmily Castaneda',
    title: 'SEC Representative',
    photo: 'https://static.wixstatic.com/media/dac086_381dc2b1f4744850964959ca9169db53~mv2.jpg',
    major: 'Electrical and Computer Engineering',
    email: 'escastaneda@vt.edu',
    linkedin: 'https://www.linkedin.com/in/emmily-castaneda/',
  },
  //FREP
  {
    name: 'Franco Giudici',
    title: 'Freshman Representative',
    photo: '',
    major: 'General Engineering',
    email: 'francog@vt.edu',
    linkedin: 'https://www.linkedin.com/in/franco-giudici-069a6b323/',
  }
    
]
// ── RECENT EVENTS PREVIEW (last 3 events) ──────────────────
// Shows on homepage. Add photos from meetings, NLC, outreach.
/*
// ── EVENT TAG COLORS ──────────────────────────────────────────
// Add new tag colors here if you add new event types
const TAG_COLORS = {
  Conference: { bg: '#E8F0F8', color: '#1A4A7A' },
  Meeting:    { bg: '#F5E8EB', color: '#861F41' },
  Outreach:   { bg: '#E8F5EC', color: '#2D7A4F' },
  Social:     { bg: '#FFF3E8', color: '#E5751F' },
  Workshop:   { bg: '#F3E8FF', color: '#7C3AED' },
  Default:    { bg: '#F0F0F0', color: '#555' },
};
*/
export const RECENT_EVENTS = [
  {
    title: 'SHPE Fall Social',
    date: 'September 2026',
    description: 'Kicked off the semester with fun out in Slusher quad, welcoming new members and playing fun games together.',
    photo: 'https://static.wixstatic.com/media/dac086_0085615ca10c47f2bae6f54e39d573f7~mv2.jpg',   // REPLACE HERO_IMAGE as default
    tag: 'Social',
  },
  {
    title: 'Latin Link x SHPE Collab',
    date: 'October 2026',
    description: 'Hispanic Heritage Month celebration hosted along with Latin Link.',
    photo:'/images/LL.jpg',   // REPLACE HERO_IMAGE as default
    tag: 'Social',
  },
  {
    title: 'SHPE x Wells Fargo Panel Session',
    date: 'October 2026',
    description: 'Members learned and explored potential careers and insights from Wells Fargo representatives.',
    photo: process.env.PUBLIC_URL + '/images/Wells_Fargo.JPG',   // REPLACE with outreach photo
    tag: 'Meeting',
  },
];

// ── MEMBER SPOTLIGHTS ────────────────────────────────────────
export const SPOTLIGHTS = [
  {
    name: 'Sample Member',
    major: 'Computer Engineering, Class of 2025',
    internship: 'Software Engineer Intern @ Google',
    quote: 'SHPE helped me land my first internship and gave me a community that felt like family.',
    photo: '',  // REPLACE: path to member photo
  },
  // Add more spotlights...
];

// ── SPONSORS ─────────────────────────────────────────────────
export const SPONSORS = [
  { name: 'Capital One',     logo: 'https://static.wixstatic.com/media/dac086_cfecceea3b0f4dcca1f0b4a366822218~mv2.png', tier: 'gold' },
  { name: 'Black & Veatch',  logo: 'https://static.wixstatic.com/media/dac086_e9092694647b4bae9eea7ba163e60810~mv2.png', tier: 'silver' },
  //{ name: 'Deloitte',        logo: 'https://static.wixstatic.com/media/dac086_4a47dca579f948d7958d86d0f5ca2706~mv2.png', tier: 'silver' },
  {name: 'Whiting-Turner', logo: '/images/WT-Orange-1.png', tier: 'silver'},
  //{ name: 'Micron',          logo: 'https://static.wixstatic.com/media/dac086_36670886f8cd4b7dbb7e424a0758e0a8~mv2.webp', tier: 'silver' },
  { name: 'Altec',           logo: 'https://static.wixstatic.com/media/dac086_e68b803dc05d4be7afe37afb49b5a89e~mv2.png', tier: 'bronze' },
  { name: 'Bank of America', logo: 'https://static.wixstatic.com/media/dac086_d587ef3ff65041e5adf3632737c714f3~mv2.jpg', tier: 'bronze' },
  { name: 'Dominion Energy', logo: 'https://static.wixstatic.com/media/dac086_829a15d063b44bcc9ff89302d003e375~mv2.jpg', tier: 'bronze' },
  {name: 'Moog', logo: 'https://static.wixstatic.com/media/dac086_e1e85620d88e4ff98552110a21da216a~mv2.png', tier: 'bronze'},
  {name: 'Virginia Paving', logo: 'https://static.wixstatic.com/media/dac086_99d0727afc434ba781a90d4108aaf153~mv2.jpg', tier: 'silver'},
  // ── ADD MORE SPONSORS ──
  // { name: 'Company Name', logo: '/images/sponsor-company.png', tier: 'gold' | 'silver' | 'bronze' },
];

// ── ALUMNI & DONOR RECOGNITION ──────────────────────────────
// Shown on the Sponsors page as a "Wall of Support" beneath the corporate
// sponsor tiers. Add one entry per alumnus/donor who has agreed to be
// publicly named — check with whoever manages donor relations before
// adding anyone.
//
//   name       — required
//   classYear  — optional, e.g. "'22" — shown as a small superscript
//   tier       — optional: 'gold' | 'silver' | 'bronze' — larger/bolder
//                text for bigger gifts; leave unset for the standard style
//   anonymous  — optional: true — shows "Anonymous Donor" instead of a name
//
// No dollar amounts are shown by design — this is a thank-you wall, not a
// ledger. Add amounts yourself if your chapter prefers that instead.
export const ALUMNI_DONORS = [
  { name: 'Sebastian Buenano'},
  { name: 'Fernando Gomez', classYear: "'25" },
  { name: 'Bryan Angel'},
  { name: 'Dario Villagomez', classYear: "'25" },
  { name: 'Esteban Rodriguez', classYear: "'24" },
  { name: 'Diego Salazar Jara', classYear: "'25" },
  { name: 'Luis Tovar', classYear: "'25" },
  // { anonymous: true },
];

// ── SITE STATS (update each semester) ───────────────────────
export const STATS = [
  { value: '120+', label: 'Active Members' },
  { value: '25+',  label: 'Majors Represented' },
  { value: '8',    label: 'Corporate Partners' },
  { value: '3',    label: 'Annual Conferences' },
];